export default __webpack_public_path__ + "static/media/red-warn.7069b34e.svg";